const mEditionAssetContents = {
  mEditionAssetContents: {
    alerts: {
      updateContenidoJerarquiasNodos: {
        error: 'Un error ha ocurrido. Vuelve a intentarlo en un momento.',
        success: 'El orden de los contenidos fue actualizado exitosamente.'
      }
    },

    buttonSecondary: {
      createNodeText: 'Nuevo'
    },

    quote: {
      firstText: 'Aún no tienes versiones de contenido generadas para tu curso.',
      secondText: 'Aquí puedes crear versiones y agrupar los diferentes contenidos.',
      thirdText: 'Aún no tienes contenidos creados en tu curso.',
      fourthText: 'Aquí puedes crear contenidos y utilizar el editor para agregar textos, audios, documentos, videos y enlaces.'
    }
  }
}

export default mEditionAssetContents
